import React, {ReactElement} from "react";

export function ProcessorHeader({title, children}: { title: string, children?: ReactElement }) {
    return (<div className="card-header">
        <div>
            <h3 className="card-title">{title}</h3>
        </div>
        {children && <div className="processor-header-buttons">{children}</div>}
    </div>)
}
